/* iPad/iOS workaround — Judge.me "full review" lightbox close (×) button.

   Judge.me's review lightbox is built on Magnific Popup, which has a long-standing iOS bug: on a real
   iPad the close (×) button's tap animates but never fires the delegated click, so the modal won't close
   (tapping the dark backdrop still closes it). See Magnific-Popup issue #478. It only reproduces with a
   genuine touch — a desktop/responsive-mode mouse click works, which is why it can't be reproduced in
   dev tools.

   The modal is injected at runtime by the app; the theme doesn't own its markup or handlers. So instead
   of trying to fix the app, we bridge a real TAP on `.jm-mfp-close` into a programmatic `.click()`, which
   the app's own close handler DOES respond to (the same reason `$.magnificPopup.close()` works from the
   console). Scoped to that one button, touch-only, and tap-guarded (ignores swipes/scrolls), so it never
   runs on desktop and is a no-op on any page without the app modal present. */
(function () {
  if (window.__coJmCloseFix) return;
  window.__coJmCloseFix = true;

  var startX = 0;
  var startY = 0;
  var moved = false;
  var MOVE_TOLERANCE = 10; // px — beyond this the touch is a scroll/swipe, not a tap

  document.addEventListener(
    'touchstart',
    function (e) {
      var t = e.changedTouches && e.changedTouches[0];
      if (!t) return;
      startX = t.clientX;
      startY = t.clientY;
      moved = false;
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (e) {
      var t = e.changedTouches && e.changedTouches[0];
      if (t && (Math.abs(t.clientX - startX) > MOVE_TOLERANCE || Math.abs(t.clientY - startY) > MOVE_TOLERANCE)) {
        moved = true;
      }
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'touchend',
    function (e) {
      if (moved) return; // it was a scroll/swipe, not a tap on the ×
      var target = e.target;
      var btn = target && target.closest ? target.closest('.jm-mfp-close') : null;
      if (!btn) return;
      e.preventDefault(); // suppress the (broken) emulated click so the close isn't double-handled
      btn.click(); // a dispatched click reaches the app's delegated close handler, unlike the iOS tap
    },
    { capture: true, passive: false }
  );
})();
